import { render, staticRenderFns } from "./ProductLicenseIndex.vue?vue&type=template&id=3a1def9a&scoped=true&"
import script from "./ProductLicenseIndex.vue?vue&type=script&lang=js&"
export * from "./ProductLicenseIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProductLicenseIndex.vue?vue&type=style&index=0&id=3a1def9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1def9a",
  null
  
)

export default component.exports